/*
 * "Nirvik Ready for organizations" (/guides/organizations), the general
 * guide, also printed to its PDF (/guides/organizations/print). Its own
 * opening and playbook around the shared chapters; screenshots for every
 * guide live in apps/web/public/guides/organizations/shots/.
 */
import whyReady from './00-why.md?raw';
import playbook from './15-launch-playbook.md?raw';
import { sharedChapters } from '../chapters';
import type { Guide } from '../types';

const s = sharedChapters(null);

export const organizationsGuide: Guide = {
  slug: 'organizations',
  title: 'Nirvik Ready for organizations',
  subtitle:
    'How universities, non-profits, companies and communities run cyber and AI readiness for their people, from sign-up to their own courses and workshops.',
  audiences: ['organizations'],
  pdf: '/guides/organizations/nirvik-ready-guide.pdf',
  reviewed: '2026-10-25',
  chapters: [
    {
      slug: 'why',
      title: 'Why Nirvik Ready',
      summary: 'What it is and who it’s for',
      markdown: whyReady,
    },
    s['at-a-glance'],
    s['getting-started'],
    s['set-up'],
    s.people,
    s['ready-made'],
    s['make-it-yours'],
    s['build-a-course'],
    s.assessments,
    s.events,
    s.assign,
    s['spread-the-word'],
    s.impact,
    s.support,
    s.trust,
    {
      slug: 'launch-playbook',
      title: 'Launch playbook',
      summary: 'Your first 90 days, week by week',
      markdown: playbook,
    },
    s['checklists-faq'],
  ],
};
